<template>
  <div class="container">
    <van-nav-bar
      title="报修处理"
      left-text=""
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="list-box">
       <div class="list">故障原因：{{objDetail.repairReason&&objDetail.repairReason.name}}</div>
       <div class="list">联系人电话：{{objDetail.mobile}}</div>
      <div class="list">提交报修时间：{{objDetail.createTime}}</div>
      <div class="list">告警位置：{{objDetail.device&&objDetail.device.location}}</div>
      <div class="list" @click="goDetail">设备编号：<span class="col_b">{{objDetail.mainNo}}&nbsp;<van-icon name="eye-o" /></span></div>
      <div class="list">插座编号：{{objDetail.loopNo}}</div>
      <div class="list">备注：{{objDetail.repairRemark}}</div>
         <div class="list">照片:</div>
        <div class="list" v-for="(item,index) in objDetail.pictures" :key="index" style="display:inline-block;width:33%">
          <img  :src="item+'?x-oss-process=style/w512'" alt="" style="width:98%;height:100px" @click="showPic(objDetail.pictures,index)">
        </div>
      <!-- 已处理 -->
      <div class="" v-if="handleStatus">
        <van-divider>处理情况</van-divider>
        <div class="list">处理结果：{{objDetail.handleResult&&objDetail.handleResult.name}}</div>
        <div class="list">处理人：{{objDetail.updateUserName}}</div>
        <div class="list">处理报修时间：{{objDetail.handleTime}}</div>
        <div class="list message">备注：{{objDetail.remark}}</div>
         <div class="list">照片:</div>
        <div class="list" v-for="(item,index) in objDetail.handlePictures" :key="index" style="display:inline-block;width:33%">
          <img  :src="item+'?x-oss-process=style/w512'" alt="" style="width:100%;height:100px"  @click="showPic(objDetail.handlePictures,index)">
        </div>
      </div>
      <van-button color="#2FAAFF" block type="info" style="position:fixed;bottom:30px;left:5%;width:90%" @click="show=true" v-else>前往处理</van-button>
      <!-- 未处理 -->
      <van-popup
        v-model:show="show"
        closeable
        position="bottom"
        :style="{ height: '80%' }"
      >
      <div style="padding: 0 10px">
        <div class="list" style="padding-top:28px"><span class="col_r">*</span>处理结果：</div>
        <div class="btn-box">
          <span @click="selBtn(item)" :class="item.id == active?'active':''" class="btns" :key="index" v-for="(item,index) in warnResultList">{{item.name}}</span>
        </div>
        <div class="list">处理描述：</div>
        <div class="list">
          <van-field
            v-model="message"
            rows="3"
            :border='true'
            label=""
            type="textarea"
            maxlength="200"
            placeholder="请输入处理描述"
          />
        </div>
        <div class="list"><span class="col_r">*</span> 现场照片：</div>
        <div class="upImg">
          <van-uploader
            v-model="imgList"
            :max-count="3"
            :max-size="10485760"
          />
        </div>
        <div class="btnbox">
          <van-button color="#2FAAFF" round block type="info" @click="checkData">提交</van-button>
        </div>
</div>
      </van-popup>
    </div>
    
  </div>
</template>

<script>
  import axios from '@/axios.js';
  import {uploadFiles} from '@/upload.js';
  import Vue from 'vue';
  import {NavBar,Icon,Toast,Loading,Field,Button,Uploader,Divider ,Popup ,ImagePreview } from 'vant';
  import ImageCompressor from 'image-compressor.js' //js图片压缩旋转库
  export default {
    data() {
      return {
        fromPage:'',//来源是否是订阅号
        active:'',
        handleStatus: true,//状态
        rowId:'',
        warningResult:'',//原因
        imgList:[],
        show:false,
        imgs:[],
        upImgUrl:'',
        message:'',
        objDetail:{community:{}},
        warnResultList:[],
        imgDomain: location.protocol + "//soonsmart.keji.io/",
      };
    },
    components: {
      [NavBar.name]:NavBar,
      [Icon.name]:Icon,
      [Toast.name]:Toast, 
      [Loading.name]:Loading,
      [Field.name]:Field,
      [Uploader.name]:Uploader,
      [Button.name]:Button,
      [Divider.name]:Divider,
      [Popup.name]:Popup,
      [ImagePreview.name]:ImagePreview,
    },
    methods: {
      goDetail(){
        this.$router.push({path: "deviceDetail.html",query:{id:this.objDetail.mainNo}})
      },
      changePage(Iccard,url){
        this.$router.push({path: url+".html",query:{iccard:Iccard}})
      },
      showPic(item,index){
        console.log(item)
        ImagePreview({
          images:item,
          startPosition:index,
          closeable:true
        })
      },
      onClickLeft() {
        if(this.fromPage == 1){
          //从公众号进入
          Vue.wechat.closeWindow();
        }else{
          this.$router.go(-1);
        }
        //this.$router.push({path: "warn.html",query:{isDetail:1}})
      },
      selBtn(item){
        this.active = item.id;
        this.warningResult = item.id;
      },
      beforeRead(file) {
        var that = this;
        if(file.length != undefined){
          Toast('只能选择1张图片');
          return false;
        }
        if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png' && file.type !== 'image/bmp') {
          Toast('请上传 jpg jpeg png bmp 格式图片');
          return false;
        } else if (file.size > 10485760 ) {
          Toast('请上传不大于 10M 的图片');
          return false;
        } else{
          new ImageCompressor(file, {
            quality: 0.6, //压缩质量
            checkOrientation: false,//指示是否读取图像的Exif方向值(仅为JPEG图像)，然后使用该值自动旋转或翻转图像。默认true
            success(result) {
              //压缩后的文件会自动转换成二进制文件流类型
              //这里可以发ajax，上传图片
              Toast.loading({
                duration: 0,       // 持续展示 toast
                forbidClick: true, // 禁用背景点击
                loadingType: 'spinner',
                message: '图片上传中...'
              });
              that.uprightSuc(result.name,result);
            }
          })
          return true;
        }
        
      },
      delImg(aa){
        console.log(aa)
        // this.upImgUrl = '';
        return true;
      },
      uprightSuc(imgName, imgFile) {
          let that = this;
          uploadFiles(imgName, imgFile)
          .then(function (result) {
            console.log(result);
            //_this.upImgUrl = result.name;
            that.imgs.push(result.name);
            let len = that.imgs.length;
            if (len == that.imgList.length) {
              Toast.clear();
              that.upCheckList();
            }
          })
          .catch(function (err) {
            console.log("err", err);
          });
      },
      
      checkData(){
        if(this.warningResult === ''){
          Toast('请选择处理结果');
          return false;
        }else if(this.imgList.length==0){
          Toast('请上传现场照片');
          return false;
        }else{
          Toast.loading({
          duration: 1000,       // 持续展示 toast
          forbidClick: true, // 禁用背景点击
          loadingType: 'spinner',
          message: '图片上传中...'
        });
          this.imgs=[];
          let _this = this
          
          _this.imgList.forEach((item,index)=>{
            new ImageCompressor(item.file, {
            quality: 0.6, //压缩质量
            checkOrientation: false,//指示是否读取图像的Exif方向值(仅为JPEG图像)，然后使用该值自动旋转或翻转图像。默认true
            success(result) {
              //压缩后的文件会自动转换成二进制文件流类型
              //这里可以发ajax，上传图片
              _this.uprightSuc(result.name,result);
            }
          })
          })
          
        }
      },
      upCheckList() {
        //上传
        Toast.loading({
          duration: 500,       // 持续展示 toast
          forbidClick: true, // 禁用背景点击
          loadingType: 'spinner',
          message: '提交中请稍后...'
        });
        axios.post("/repair/update?id="+this.rowId,{
          handleResultId: this.warningResult,
          handlePictures: this.imgs.join(','),
          remark: this.message,
        }).then((res)=>{
          if(res.isSuccess){
            Toast('提交成功');
            setTimeout(()=>{
              this.$router.push({path: "warn.html",query:{isDetail:1}})
            },500)
          }
        })
      },
      getDetail() {
        //获取详情
        axios.get("repair/getdetail?id="+this.rowId,{
        }).then((res)=>{
          this.objDetail = res.data;
          this.handleStatus = res.data.handleStatus;
          if(res.data.handlePictures){
            let handlePictures=res.data.handlePictures.split(',')
            this.objDetail.handlePictures=[]
            handlePictures.forEach(item=>{
              item=this.imgDomain+item
              this.objDetail.handlePictures.push(item)
            })
          }
          if(res.data.pictures){this.objDetail.pictures=res.data.pictures.split(',')}
        })

        //处理结果
        axios.get("dictdetail/getdictdetailbyparentcode?dictCode=HandleResult",{
        }).then((res)=>{
          this.warnResultList = res.data;
        })

        // //标记已读
        // axios.get("/device/readdevicewarning?id="+this.rowId,{
        // }).then(()=>{
        // })
      },
     
    },
    computed:{},
    created () {
      this.rowId = this.$route.query.rowId;
      this.fromPage = this.$route.query.fromPage;
      this.getDetail();
    },
    mounted () {
    },
  }
</script>

<style lang="less" scoped>
  body,html{width: 100%;height: 100%;background: #fff}
  .container{
    width: 100%;min-height: 100vh;letter-spacing:0px;background: #fff;
    padding-bottom: 100px;
  }
  .list-box{
    color: #373737;
    padding: 12px 20px 0 20px;
    .list{
      font-size: 14px;
      width: 100%;
      margin-bottom: 10px;
      .width200{width: 200px; display: inline-block;}
    }
  }
  .btns{
    width: 86px;
    height: 30px;
    line-height: 30px;
    display: inline-block;
    text-align: center;
    font-size: 14px;
    border: 1px solid #c8d1db;
    border-radius: 4px;
    margin: 0 10px 20px 0;
  }
  .message{
    width: 100%;
    word-break: break-all;
  }
  .active{
    color: #fff;
    background: #2FAAFF;
    border: 1px solid #2FAAFF;
  }
  .upImg{
    .van-uploader__upload{width: 60px !important;height: 60px !important;}
  }

  .btnbox{
    width: 100%;
    padding: 0 30px;
    position: fixed;
    left: 0;
    bottom: 40px;
  }
  /deep/.van-field{
    border: 1px solid #c8d1db;
    border-radius: 4px;
  }
</style>
